import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "style-trans"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-fire text-danger" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass({
            'style-tag':_ctx.name_class==='style',
            'genre-tag':_ctx.name_class=='genre',
            'is_full':_ctx.full===1,
        })
  }, [
    _createVNode(_component_RouterLink, {
      to: {
                path:_ctx.target_path,
            }
    }, {
      default: _withCtx(() => [
        _createElementVNode("ruby", null, [
          _createTextVNode(_toDisplayString(_ctx.genre.name || _ctx.genre.name_orig) + " ", 1),
          _createElementVNode("rp", null, _toDisplayString(_ctx.genre.name || _ctx.genre.name_orig), 1),
          _createElementVNode("rt", null, [
            (_ctx.full==1 && _ctx.genre.name!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.genre.name_orig), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    (_ctx.hot>0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.hot), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}